import React from 'react';
import classNames from 'classnames';
import Track from '../Base/Sensors/track';
import scrollIt from '../Base/Scroll';

const AOListNavigation = ({
  alphabet,
  compare,
  activeLetter,
  handleLetterChange,
  ...props
}) => {
  const Anchors = alphabet.map((Key) => {
    return { Key };
  });

  const classes = classNames({
    'c-anchorlinks': true,
    'c-anchorlinks--is-fixed': props.isWithinTrac,
    'c-anchorlinks--is-bottom': props.isTrackBottom,
  });

  return (
    <ul className={classes}>
      {Anchors.map((item, index) => {
        const matched = typeof compare !== 'undefined' ? compare(item) : true;

        const classes = classNames({
          'c-anchorlinks__item': true,
          'c-anchorlinks__item--selected':
            activeLetter.toLowerCase() === item.Key.toLowerCase(),
          'c-anchorlinks__item--matched': matched,
        });

        const attributes = {
          'data-cy': matched ? 'ui-anchor-item' : 'ui-empty-item',
        };

        return (
          <li key={index}>
            {matched ? (
              <a
                {...attributes}
                className={classes}
                id={`nav-${item.Key}`}
                href={`#${item.Key}`}
                onClick={() => {
                  if (!document.getElementById(`${item.Key}`)) return false;
                  scrollIt(
                    document.getElementById(`${item.Key}`),
                    300,
                    'easeOutQuad',
                    () => {
                      if (typeof handleLetterChange !== 'undefined')
                        handleLetterChange(item.Key);
                      //if (typeof onClickedAnchor !== 'undefined') onClickedAnchor(false);
                    }
                  );
                }}
              >
                {item.Key}
              </a>
            ) : (
              <span {...attributes} className={classes}>
                {item.Key}
              </span>
            )}
          </li>
        );
      })}
    </ul>
  );
};

export default Track(AOListNavigation);
